var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({'border-radius': _vm.rad})},[_c('span',{staticClass:"material-icons"},[_vm._v(" "+_vm._s(_vm.btnIcon)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }